module.exports = __webpack_public_path__ + "img/instagram.cc315ade.svg";